// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const skarmory: PokeData = {
  "id": 227,
  "name": "skarmory",
  "height": 17,
  "weight": 505,
  "base_experience": 163,
  "types": [
    PokeType.STEEL,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "sand-attack",
    "fury-attack",
    "leer",
    "peck",
    "drill-peck",
    "agility",
    "swift",
    "slash",
    "spikes",
    "steel-wing",
    "metal-claw",
    "air-cutter",
    "metal-sound",
    "iron-defense",
    "feint",
    "payback",
    "night-slash",
    "air-slash",
    "brave-bird",
    "autotomize"
  ],
  "moves": [
    "leer",
    "peck",
    "metal-claw",
    "metal-sound",
    "night-slash",
    "air-slash",
    "brave-bird",
    "gust",
    "behemoth-bash",
    "aerial-ace",
    "magnet-pull",
    "steel-beam",
    "metal-burst"
  ],
  "evolution_chain": {
    "id": 117,
    "item": null,
    "species": [
      {
        "name": "skarmory",
        "order": 260,
        "types": [
          PokeType.STEEL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 145,
    "speed": 119,
    "ability_power": 136
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
